/**
 * SPDX-License-Identifier: MPL-2.0
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import { MachineAction } from './MachinesActions';
import { IMachine } from '@umati/dashboard-types';
import { createReducer } from '@reduxjs/toolkit';

interface IMachineStore {
  machinesRequested: boolean;
  machines: IMachine[];
  requestedToDelete: IMachine['Id'][];
  deleted: IMachine[];
  requestedToEditShortId: IMachine['Id'][];
  shortIdsEdited: IMachine['Id'][];
}

const initialState: IMachineStore = {
  machinesRequested: false,
  machines: [],
  requestedToDelete: [],
  deleted: [],
  requestedToEditShortId: [],
  shortIdsEdited: [],
};

const MachinesReducer = createReducer<IMachineStore>(initialState, (builder) => {
  builder
    .addCase(MachineAction.Query, (state) => {
      return {
        ...state,
        machinesRequested: true,
      };
    })
    .addCase(MachineAction.Queried, (state, action) => {
      return {
        ...state,
        machinesRequested: false,
        machines: action.payload,
      };
    })
    .addCase(MachineAction.Delete, (state, action) => {
      const requestedToDelete = [...state.requestedToDelete];
      requestedToDelete.push(action.payload);
      return {
        ...state,
        requestedToDelete,
      };
    })
    .addCase(MachineAction.Deleted, (state, action) => {
      const deleted = [...state.deleted];
      deleted.push(action.payload);
      return {
        ...state,
        machines: state.machines.filter((machine) => machine.Id !== action.payload.Id),
        deleted,
        requestedToDelete: state.requestedToDelete.filter((el) => el !== action.payload.Id),
      };
    })
    .addCase(MachineAction.ShortId_Edit, (state, action) => {
      const requestedToEditShortId = [...state.requestedToEditShortId];
      requestedToEditShortId.push(action.payload.id);
      return {
        ...state,
        requestedToEditShortId,
      };
    })
    .addCase(MachineAction.ShortId_Edited, (state, action) => {
      const shortIdsEdited = [...state.shortIdsEdited];
      shortIdsEdited.push(action.payload.Id);
      const machines = state.machines.filter((machine) => machine.Id !== action.payload.Id);
      machines.push(action.payload);
      return {
        ...state,
        machines,
        shortIdsEdited,
        requestedToEditShortId: state.requestedToEditShortId.filter((el) => el !== action.payload.Id),
      };
    })
    .addCase(MachineAction.Updated, (state, action) => {
      const machines = [...state.machines].filter((machine) => machine.Id !== action.payload.Id);
      machines.push(action.payload);
      return {
        ...state,
        machines,
      };
    });
});

export default MachinesReducer;
